<template>
  <v-row no-gutters>
    <v-col cols="12" class="d-flex align-center justify-space-around pa-5">
      <v-row no-gutters>
        <v-col
          cols="6"
          lg="3"
          v-for="label in labels"
          :key="`label-${label.color}`"
          class="d-flex align-center px-2 mb-sm-2"
        >
          <div class="color-box mr-5" :class="label.color"></div>
          <span class="label">{{ label.name.toUpperCase() }}</span>
          <v-tooltip v-if="label.tooltip" bottom :max-width="tooltipMaxWidth">
            <template v-slot:activator="{ on }">
              <v-icon small color="primary" v-on="on" class="ml-1">
                mdi-information-outline
              </v-icon>
            </template>
            <span>{{ label.tooltip }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AuditSummaryCustomChartLegend",
  data() {
    return {
      tooltipMaxWidth: 500,
      labels: [
        {
          name: this.$t("message.common.seo"),
          color: "blue",
          tooltip: this.$t("message.analytics.tooltip.seo")
        },
        {
          name: this.$t("message.common.performance"),
          color: "red",
          tooltip: this.$t("message.analytics.tooltip.performance")
        },
        {
          name: this.$t("message.common.accessibility"),
          color: "orange",
          tooltip: this.$t("message.analytics.tooltip.accessibility")
        },
        {
          name: this.$t("message.common.bestPractices"),
          color: "green",
          tooltip: this.$t("message.analytics.tooltip.best_practices")
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.label {
  display: block;
  position: relative;
}

.color-box {
  height: 5px;
  width: 50px;
  border-radius: 5px;
}
</style>
